'use es6';

export const LIVE = 1;
export const STAGED = 2;